import {awardsActions} from '../actions';
import * as Date from '../elements/dates/dateHelpers';

export default function awards(initialState = {}, action) {
    const newState = {...initialState};
    switch (action.type) {
        case awardsActions.SET_AWARDS: return setAwardsReducer(newState, action);
        case awardsActions.GENERAL_AWARDS_REQUEST: return setAwardsReducer(newState, action);
        case awardsActions.GENERAL_AWARDS_SUCCESS: return createAndEditReducer(newState, action);
        case awardsActions.DELETE_AWARDS_SUCCESS: return deleteReducer(newState, action);
        case awardsActions.GENERAL_AWARDS_ERROR: return setAwardsReducer(newState, action);
        default: return newState;
    }
}

function setAwardsReducer(newState, action) {
    delete action.type;
    newState = Object.assign(newState, {...action});
    return newState;
}

function createAndEditReducer(newState, action) {
    delete action.type;
    delete action.body.type;

    const itemIndex = newState.body.find( item => item.id === action.body.id );


    if ( !itemIndex ) {
        newState.body.push( action.body )
    } else {
        newState.body[ newState.body.indexOf( itemIndex ) ] = action.body;
    }

    let arrCopy = [...newState.body], orderedArr = Date.orderByDate( arrCopy );

    newState.body = [...orderedArr];

    return newState;
}


function deleteReducer(newState, action) {
    delete action.type;
    newState.body = newState.body.filter(e => e.id !== action.body);
    return newState;
}




// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/awards.js